/**
 * AppICEMAP — Confirmations API
 * Fetch and create report confirmations (votes).
 */

import { getClient, readItems, createItem } from "./directus.js";

const CONFIRMATIONS_COLLECTION = "confirmations";

/**
 * Fetch the current user's vote for a specific report.
 * @param {string} reportId
 * @returns {Promise<object | null>}
 */
export async function fetchUserVote(reportId) {
	const client = getClient();

	try {
		const result = await client.request(
			readItems(CONFIRMATIONS_COLLECTION, {
				fields: ["id", "type", "created_at"],
				filter: {
					report: { _eq: reportId },
				},
				limit: 1,
			}),
		);
		return (result && result[0]) || null;
	} catch (err) {
		console.error("[API] fetchUserVote error:", err);
		return null;
	}
}

/**
 * Create a confirmation (vote) on a report.
 * @param {{ report: string, type: 'confirm' | 'deny' | 'resolve' }} payload
 * @returns {Promise<object>}
 */
export async function createConfirmation(payload) {
	const client = getClient();

	try {
		const result = await client.request(
			createItem(CONFIRMATIONS_COLLECTION, payload),
		);
		return result;
	} catch (err) {
		console.error("[API] createConfirmation error:", err);
		throw err;
	}
}
